/**
 * Header superior sticky.
 */
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useLogout } from '@/api/useAuth';
import { Breadcrumb, type Crumb } from '@/components/shared/navigation/Breadcrumb';
import type { ReactNode } from 'react';

type HeaderProps = {
  crumbs?: Crumb[];
  rightSlot?: ReactNode;
};

export function Header({ crumbs = [], rightSlot }: HeaderProps) {
  const { user, isSuperuser } = useAuth();
  const { mutate: logout } = useLogout();

  return (
    <header
      role="banner"
      className="sticky top-0 z-40 flex h-[60px] items-center justify-between border-b border-slate-200 bg-white px-4 shadow-sm"
    >
      <div className="ml-12 lg:ml-0">
        {crumbs.length > 0 ? <Breadcrumb crumbs={crumbs} /> : <span className="text-xs text-slate-500">Inicio</span>}
      </div>
      <div className="flex items-center gap-3">
        {rightSlot}
        {user && (
          <>
            {isSuperuser ? (
              <span className="rounded bg-primary/10 px-2 py-1 text-xs font-medium text-primary">
                Super Administrador
              </span>
            ) : user.tenant_name ? (
              <span className="text-xs text-slate-600">{user.tenant_name}</span>
            ) : null}
            <Link
              to="/app/profile"
              className="flex items-center gap-2 rounded-md px-2 py-1 hover:bg-slate-100"
            >
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-xs font-semibold text-white">
                {(user.full_name || user.email || '?').split(' ').map((n) => n[0]).slice(0, 2).join('').toUpperCase()}
              </div>
              <div className="hidden text-left sm:block">
                <p className="text-xs font-medium text-slate-900">{user.full_name || '—'}</p>
                <p className="text-[10px] text-slate-500">{user.email}</p>
              </div>
            </Link>
            <span className="h-6 w-px bg-slate-200" />
            <button
              type="button"
              onClick={() => logout()}
              className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-slate-600 hover:text-error"
              aria-label="Cerrar sesion"
            >
              <span className="material-symbols-outlined text-[18px]">logout</span>
              <span className="hidden sm:inline">Salir</span>
            </button>
          </>
        )}
      </div>
    </header>
  );
}
